(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimoni"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function parseVideoUrl(raw) {
    if (!raw) return null;
    raw = raw.trim();

    if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) {
      return { provider: 'youtube', id: raw };
    }

    var ytMatch = raw.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (ytMatch) return { provider: 'youtube', id: ytMatch[1] };

    var vmMatch = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vmMatch) return { provider: 'vimeo', id: vmMatch[1] };

    if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(raw)) {
      return { provider: 'direct', id: raw };
    }

    return null;
  }

  function buildPlayer(video) {
    if (!video) return '';

    if (video.provider === 'youtube') {
      return '<iframe src="https://www.youtube.com/embed/' + video.id
        + '?autoplay=1&rel=0&modestbranding=1&playsinline=1" '
        + 'title="Video testimoni" '
        + 'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" '
        + 'allowfullscreen></iframe>';
    }

    if (video.provider === 'vimeo') {
      return '<iframe src="https://player.vimeo.com/video/' + video.id
        + '?autoplay=1&title=0&byline=0&portrait=0" '
        + 'title="Video testimoni" '
        + 'allow="autoplay; fullscreen; picture-in-picture" '
        + 'allowfullscreen></iframe>';
    }

    if (video.provider === 'direct') {
      return '<video src="' + video.id + '" controls autoplay playsinline></video>';
    }

    return '';
  }

  var prefersReducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Inline card videos: play only while in viewport, pause when out.
  function initInlineAutoplay(sectionEl) {
    if (prefersReducedMotion) return;
    var vids = sectionEl.querySelectorAll('.kg-card__video[data-kg-autoplay="true"]');
    if (!vids.length) return;

    function tryPlay(v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function() {}); }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) {
          if (en.isIntersecting) { tryPlay(en.target); }
          else { en.target.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function(v) { io.observe(v); });
    } else {
      vids.forEach(tryPlay);
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    var sid = sectionEl.dataset.kgSection;
    var modal = document.getElementById('kg-modal-' + sid);
    if (!modal) return;

    var inner = modal.querySelector('.kg-modal__inner');
    var frameWrap = modal.querySelector('.kg-modal__frame-wrap');
    var closeBtn = modal.querySelector('.kg-modal__close');
    var cards = sectionEl.querySelectorAll('.kg-card');
    var lastFocused = null;

    function openVideo(url, orientation) {
      var video = parseVideoUrl(url);
      if (!video) {
        console.warn('[kg-testimony] Invalid or empty video source:', url);
        return;
      }
      lastFocused = document.activeElement;
      frameWrap.innerHTML = buildPlayer(video);
      inner.setAttribute('data-orientation', orientation === 'portrait' ? 'portrait' : 'landscape');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeVideo() {
      modal.hidden = true;
      frameWrap.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        openVideo(card.dataset.videoUrl, card.dataset.videoOrientation);
      });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openVideo(card.dataset.videoUrl, card.dataset.videoOrientation);
        }
      });
    });

    closeBtn.addEventListener('click', closeVideo);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeVideo();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) closeVideo();
    });

    initInlineAutoplay(sectionEl);
  }

  function initAll() {
    document.querySelectorAll('[data-kg-section]').forEach(initSection);
  }

  function handleHashScroll() {
    if (!window.location.hash) return;
    var target = document.querySelector(window.location.hash);
    if (!target || !target.classList.contains('kg-testimony')) return;
    window.setTimeout(function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', handleHashScroll);
  window.addEventListener('hashchange', handleHashScroll);

  document.addEventListener('shopify:section:load', function(e) {
    var sectionEl = e.target.querySelector('[data-kg-section]');
    initSection(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
